
import { Options, Vue } from "vue-class-component";

type InputType =
  | "text"
  | "password"
  | "email"
  | "search"
  | "url"
  | "date"
  | "time"
  | "number";

@Options({
  emits: ["input", "enter"],
  props: {
    label: String,
    name: String,
    type: String,
    placeholder: String,
    value: String,
    suffix: String,
    invalid: Boolean,
    invalidMessage: String,
    entered: Boolean,
    disabled: Boolean
  }
})
export default class MTextField extends Vue {
  label = "";
  name = "";
  type: InputType = "text";
  placeholder = "";
  value = "";
  suffix = "";
  invalid = false;
  invalidMessage = "";
  entered = false;
  disabled = false;

  get dynamicClasses(): string {
    const classes: string[] = [];

    if (this.invalid && this.entered) {
      classes.push("border-red-400");
    } else {
      classes.push("border-primary-100");
    }

    return classes.join(" ");
  }

  onBlur() {
    this.$emit("enter");
  }
}
